import React from 'react';
import { Trophy } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gaming-purple/10 relative border-y border-gaming-purple/20" data-id="element-196">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10 mix-blend-overlay" data-id="element-197"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-198">
        <Trophy className="w-16 h-16 text-gaming-purple-light mx-auto mb-6 drop-shadow-[0_0_15px_rgba(168,85,247,0.8)]" data-id="element-199" />

        <h2 className="font-orbitron text-2xl md:text-4xl font-bold text-white mb-8 leading-tight" data-id="element-200">
          En los próximos{' '}
          <span className="text-gaming-purple-light text-glow-purple" data-id="element-201">
            7 días
          </span>
          , verás cómo tu contador de espectadores deja de estar en cero
          permanentemente.
        </h2>

        <p className="text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto" data-id="element-202">
          No necesitas ser un pro-player; solo necesitas aplicar la{' '}
          <strong className="text-white" data-id="element-203">Regla de los 3 Minutos</strong> para
          que cada persona que entre a tu canal se convierta en un seguidor
          leal.
        </p>
      </div>
    </section>;
}